import smoothscroll from 'smoothscroll-polyfill';

const scrollToRef = (ref, marginTop = 0) => {
  smoothscroll.polyfill();

  if (!ref || !ref.current) {
    return;
  }
  window.scrollTo({
    behavior: 'smooth',
    top: ref.current.offsetTop - marginTop,
  });
  ref.current.focus({ preventScroll: true });
};

export default scrollToRef;
